import React, { useState } from "react";
import useTranslation from "next-translate/useTranslation";
import JoinStyles from "../styles/JoinGame.module.css";
import styles from "./CLobby.module.css";

import { useUser } from "../../../redux/user";
import { FaDiceSix } from "react-icons/fa";
import { setBlinkingDaily, useDaily } from "../../../redux/daily";
// import { useStats } from "../../../ducks/stats";
import { FaPaperPlane } from "react-icons/fa";
import { FaChessRook } from "react-icons/fa";
import { FaClock } from "react-icons/fa";
import { FaSignal } from "react-icons/fa";
import { FaUser } from "react-icons/fa";
import { joinDailyGame } from "../../shared/challengeController";
import ChallengePopup from "../../challenge/ChallengePopup";
import { VARIANT_CHESS, VariantTypes } from "@chesshotel/constants";
import { useWebPush } from "@/redux/webPush";
import WebPushPopup from "../../daily/WebPushPopup";

export default function CLobby() {
  const { id } = useUser();
  // const { chess, chess960 } = useStats();
  const { t } = useTranslation("common");
  const { t: lobbyT } = useTranslation("lobby");
  const { invites } = useDaily();
  const [challengePopupOpen, setChallengePopupOpen] = useState(false);

  const [showWepPushPopup, setShowWepPushPopup] = useState(false);
  const { isSubscribed } = useWebPush();

  function handleSetShowWepPushPopup(show) {
    setShowWepPushPopup(show);
    // setDidShowWebPushPopup(true);
    // cookies.set(DID_SHOW_WEBPUSH, "1", {
    //   maxAge: ONE_WEEK,
    // });
  }

  function renderChallengeTableDataReceived() {
    return invites.map((invite) => {
      if (id === invite.userId) return;

      const classes = [];
      if (id === invite.userId) {
        classes.push(JoinStyles["removing"]);
      }

      if (invite.blink) {
        classes.push(styles.animateBlink);
      }

      return (
        <tr
          key={`invite${invite.id}`}
          onClick={() => {
            if (id !== invite.userId) {
              joinDailyGame(invite.id);
            }
          }}
          className={classes.join(" ")}
          onAnimationEnd={(e) => {
            if (e.animationName === "blink") {
              setBlinkingDaily({
                variant: invite.variantId,
                turnLength: invite.turnLength,
                userId: id,
                blinking: false,
              });
            }
          }}
        >
          <td>{invite.username}</td>
          <td>{invite.elo}</td>
          <td>{t("days", { count: invite.turnLength })}</td>
          <td>
            {invite.variantId == VariantTypes.VARIANT_CHESS ? (
              <div className="flex items-center">
                <div className="mr-1">
                  <FaPaperPlane />
                </div>
                {t("Standard")}
              </div>
            ) : (
              <div className="flex items-center">
                <div className="mr-1">
                  <FaDiceSix />
                </div>
                960
              </div>
            )}
          </td>
        </tr>
      );
    });
  }
  function renderChallengeTableDataSent() {
    return invites.map((invite) => {
      if (id !== invite.userId) return;
      if (!invite) return;
      let isEnabled = true;
      const classes = [];
      if (id === invite.userId) {
        classes.push(JoinStyles["removing"]);
        isEnabled = false;
      }
      if (invite.blink) {
        classes.push(styles.animateBlink);
      }

      return (
        <tr
          key={`invite${invite.id}`}
          onClick={() => {
            if (!isSubscribed) {
              setTimeout(() => {
                setShowWepPushPopup(true);
              }, 500);
            }
            if (id !== invite.userId) {
              joinDailyGame(invite.id);
            }
          }}
          className={classes.join(" ")}
          onAnimationEnd={(e) => {
            if (e.animationName === styles.blink) {
              setBlinkingDaily({
                variant: invite.variantId,
                turnLength: invite.turnLength,
                userId: id,
                blinking: false,
              });
            }
          }}
        >
          <td>{invite.username}</td>
          <td>{invite.elo}</td>
          <td>{t("days", { count: invite.turnLength })}</td>
          <td>
            {invite.variantId == VARIANT_CHESS ? (
              <div className="flex items-center">
                <div className="mr-1">
                  <FaPaperPlane />
                </div>
                {t("Standard")}
              </div>
            ) : (
              <div className="flex items-center">
                <div className="mr-1">
                  <FaDiceSix />
                </div>
                960
              </div>
            )}
          </td>
        </tr>
      );
    });
  }

  return (
    <>
      {showWepPushPopup && <WebPushPopup show={handleSetShowWepPushPopup} />}
      <div style={{ height: "100%" }}>
        {challengePopupOpen && (
          <ChallengePopup
            onClose={() => setChallengePopupOpen(false)}
            friend={null}
          />
        )}
        <div>
          <table className={JoinStyles.lobbyTable}>
            <colgroup>
              <col width="34%" />
              <col width="22%" />
              <col width="22%" />
              <col width="22%" />
            </colgroup>
            <thead>
              <tr>
                <th>
                  <div className="flex items-center space-x-1">
                    <div className="text-orange-400">
                      <FaUser />
                    </div>
                    <div className="hidden sm:flex">{t("Player")}</div>
                  </div>
                </th>
                <th>
                  <div className="flex items-center space-x-1">
                    <div className="text-orange-400">
                      <FaSignal />
                    </div>
                    <div className="hidden sm:flex">{t("Rating")}</div>
                  </div>
                </th>
                <th>
                  <div className="flex items-center space-x-1">
                    <div className="text-orange-400">
                      <FaClock />
                    </div>
                    <div className="hidden sm:flex">{lobbyT("Time")}</div>
                  </div>
                </th>
                <th>
                  <div className="flex items-center space-x-1">
                    <div className="text-orange-400">
                      <FaChessRook />
                    </div>
                    <div className="hidden sm:flex">{lobbyT("Mode")}</div>
                  </div>
                </th>
              </tr>
            </thead>
            <tbody>
              {renderChallengeTableDataReceived()}
              {renderChallengeTableDataSent()}
            </tbody>
          </table>
        </div>
      </div>
    </>
  );
}
